import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import Button from '@hfe/max-button';
import Sensor from '@max/mbc-sensor';
import { BizLineDesc } from '../../types/rewardRecords';
import { FREE_CARD_AMOUNT } from '../../const';
import { UNJOINED_CARD_ASSET } from './assets';
import './index.scss';
function UnJoinedActivityBannerV2(props) {
    const { feConfig, canBindBizLines } = props;
    const { unjoinedConfig, styleConfig } = feConfig ?? {};
    // 全部取运营配置（schema.js 已配 defaultValue，下方静态值仅作配置缺失兜底）
    const title = unjoinedConfig?.titleText || '邀好友助力 解锁免单卡';
    const rewardText = unjoinedConfig?.rewardText || '城市住行玩免单';
    const btnText = unjoinedConfig?.btnText || '选城市 开启好友助力';
    // 副标题 = 前缀 + 后端可核销业务（BizLineDesc）+ 后缀；后端没下发业务线时用运营配置的兜底文案，
    // 兜底也没配则置空 → 整行不展示。
    const bizNames = (canBindBizLines ?? []).map(line => BizLineDesc[line] ?? String(line));
    const subPrefix = unjoinedConfig?.subTitlePrefix ?? '先到先得，支持核销';
    const subSuffix = unjoinedConfig?.subTitleSuffix ?? '等订单';
    const subFallback = unjoinedConfig?.subTitleFallbackText ?? '';
    const subText = bizNames.length ? `${subPrefix}${bizNames.join('、')}${subSuffix}` : subFallback;
    return <View className="unjoined-banner-v2" style={{
        backgroundColor: styleConfig?.backgroundColor
    }}>
      <LinearGradient colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} className="unjoined-banner-v2__bg"/>

      <View className="unjoined-banner-v2__content">
        
        <View className="unjoined-banner-v2__header">
          <Text className="unjoined-banner-v2__title" numberOfLines={1}>{title}</Text>
          <Button className="unjoined-banner-v2__rule" onPress={() => props.onOpenFreeCardRule?.()}>
            <Text className="unjoined-banner-v2__rule-text" numberOfLines={1}>规则</Text>
            <Image className="unjoined-banner-v2__rule-arrow" source={{
        uri: UNJOINED_CARD_ASSET.RULE_ARROW
    }}/>
          </Button>
        </View>

        
        <View className="unjoined-banner-v2__panel">
          <Image className="unjoined-banner-v2__hand" source={{
        uri: UNJOINED_CARD_ASSET.HAND_BADGE
    }}/>
          <View className="unjoined-banner-v2__text-col">
            <View className="unjoined-banner-v2__reward-row">
              <Text className="unjoined-banner-v2__amount" numberOfLines={1}>{FREE_CARD_AMOUNT}</Text>
              <Text className="unjoined-banner-v2__amount-unit" numberOfLines={1}>元</Text>
              <Text className="unjoined-banner-v2__reward-text" numberOfLines={1}>{rewardText}</Text>
            </View>
            <Text x-if={!!subText} className="unjoined-banner-v2__sub" numberOfLines={1}>{subText}</Text>
          </View>
        </View>

        
        <Button className="unjoined-banner-v2__cta" onPress={() => props.onClickJoinButton()}>
          <LinearGradient colors={['#ff022e', '#fe298e']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} className="unjoined-banner-v2__cta-bg"/>
          <Sensor once onAppear={() => props.onJoinButtonShow?.()}>
            <Text className="unjoined-banner-v2__cta-text" numberOfLines={1}>{btnText}</Text>
          </Sensor>
        </Button>
      </View>
    </View>;
}
export default memo(UnJoinedActivityBannerV2);
